import { KEY_PREFIX, useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { Redirect, useLocation } from 'quartz-routing/react-router';
import { Paths } from '../../constants/paths';
import { useGates } from '../../hooks/useGates';
import { useParsedSearchResultsPathParams } from '../hooks/useParsedSearchResultsPathParams';
import { SearchResultsPage } from '../SearchResultsPage';
import { jsx as _jsx } from "react/jsx-runtime";
export function ExploreSearchResultsProxy() {
  const gates = useGates();
  const parsedPathParams = useParsedSearchResultsPathParams();
  const location = useLocation();
  const searchParams = useSearchParams();

  // /explore/page/:page → always redirect
  if (parsedPathParams.page) {
    const params = new URLSearchParams(location.search);
    params.set(`${KEY_PREFIX}page`, parsedPathParams.page.toString());
    const search = params.toString();
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: Paths.SEARCH_RESULTS_PRODUCTS,
        search: search ? `?${search}` : ''
      }
    });
  }

  // tabularSearch OFF → redirect to specific tab route (no tabs)
  if (!gates.tabularSearch) {
    const isSolutions = searchParams.get('PRODUCT_TYPE') === 'SOLUTIONS_PARTNER_PROFILE';
    return /*#__PURE__*/_jsx(Redirect, {
      to: `${isSolutions ? Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS : Paths.SEARCH_RESULTS_PRODUCTS}${location.search}`
    });
  }

  // /explore without a search query → redirect to /explore/products
  if (!searchParams.get('search')) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: `${Paths.SEARCH_RESULTS_PRODUCTS}${location.search}`
    });
  }
  return /*#__PURE__*/_jsx(SearchResultsPage, {});
}